import { render, staticRenderFns } from "./SelectPerPage.vue?vue&type=template&id=e38ab0f2&scoped=true"
import script from "./SelectPerPage.vue?vue&type=script&lang=js"
export * from "./SelectPerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38ab0f2",
  null
  
)

export default component.exports